import { Map } from 'immutable';

import { getOversetValue } from '../product/checkAttribute';
import { setTitleErrors } from '../product/errors';

import { ERROR, OPERATIONS, OVERSET, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { SHOPIFY } from '../../constants/channels';
import { FORM } from '../../constants/forms';

export function editTitle({ product: source, value }) {
  let product = source;
  const operations = [];
  const channel = product.get('channel');

  product = setTitleErrors({ product: product.setIn([FORM.TITLE, VALUE], value) });

  if (!product.getIn([FORM.TITLE, ERROR])) {
    operations.push(Map({ type: OPERATIONS[channel].TITLE, value }));

    switch (channel) {
      case SHOPIFY: {
        if (product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET])) {
          const pageTitle = getOversetValue({ attribute: ATTRIBUTE.PAGE_TITLE, product });
          product = product.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE], pageTitle);
          operations.push(Map({ type: OPERATIONS[SHOPIFY].PAGE_TITLE, value: pageTitle }));
        }

        break;
      }

      default: {
        break;
      }
    }
  }

  return { product, operations };
}
